import { Dialog, DialogTitle, LinearProgress } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showError } from "../../../../redux/common/actions";
import { deleteDefectAudio } from "services/defects/details";
import DeleteDialogStyle from "styles/application/DeleteDialogStyle";

const ADD = DeleteDialogStyle();

function DeleteDialog({
	open,
	closeHandler,
	entityName,
	defectId,
	setDetails,
}) {
	const { t } = useTranslation();
	const [isUpdating, setIsUpdating] = useState(false);
	const dispatch = useDispatch();

	const handleDeleteConfirm = async () => {
		setIsUpdating(true);
		const response = await deleteDefectAudio(defectId);

		if (!response.status)
			dispatch(
				showError(
					response?.data?.detail ||
						t("validation.couldNotDeleteEntity", { entity: entityName })
				)
			);
		else
			setDetails((prev) => ({
				...prev,
				audioURL: undefined,
			}));
		setIsUpdating(false);
		closeHandler();
	};
	return (
		<Dialog
			open={open}
			onClose={closeHandler}
			aria-labelledby="delete-title"
			aria-describedby="delete-description"
		>
			{isUpdating ? <LinearProgress /> : null}

			<ADD.ActionContainer>
				<DialogTitle id="delete-dialog-title">
					{
						<ADD.HeaderText>
							{t("title.deleteEntity", { entity: entityName })}
						</ADD.HeaderText>
					}
				</DialogTitle>
				<ADD.ButtonContainer>
					<ADD.CancelButton onClick={closeHandler} variant="contained">
						{t("action.cancel")}
					</ADD.CancelButton>
					<ADD.DeleteButton onClick={handleDeleteConfirm} variant="contained">
						{t("action.delete")}
					</ADD.DeleteButton>
				</ADD.ButtonContainer>
			</ADD.ActionContainer>

			<ADD.DialogContent>
				<ADD.InputContainer id="alert-dialog-description">
					{t("action.deleteConfirm", { name: entityName })}
				</ADD.InputContainer>
			</ADD.DialogContent>
		</Dialog>
	);
}

export default DeleteDialog;
